<script setup>

import WrContactUsCarouselSection from "~/components/global/WrContactUsCarouselSection.vue";
import WrExpertiseSection from "~/components/global/WrExpertiseSection.vue";
import WrImageContent from "~/components/global/WrImageContent.vue";
import WrOurPromiseSection from "~/components/global/WrOurPromiseSection.vue";

const data = await import("../../../public/content/services/frameworks/angularjs-development-services-content.json")

useHead({
  title: data?.meta_tags.title || "",
  meta: data?.meta_tags.meta || [],
  link: [
    {
      rel: 'preload',
      as: 'image',
      href: '/images/hero-angularjs.webp',
      fetchpriority: 'high'
    }
  ]
});

definePageMeta({
  layout: "services-layout",
});

const visible = ref(false);
const openModal = () => {
  visible.value = true;
};
const imageContent = `Ready to hire us? <span class="hover:no-underline dark:text-white underline cursor-pointer"'>Click here</span> and let’s get cracking!`;
</script>

<template>
  <section
    class=" mx-auto min-h-[386px] h-full w-full relative before:content-[''] before:z-10 before:block before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-[#5f4ca4] before:opacity-75">
   <img 
    src="/images/hero-angularjs.webp" 
    alt="Hero AngularJS Banner"
    class="absolute inset-0 w-full h-full object-cover object-center z-0"
    fetchpriority="high"
    >
    <div class="max-w-screen-xl px-4 pb-6 relative mx-auto text-center  z-30">
      <h1 class="xl:text-[57px] text-[37px] leading-[1.125] text-white text-center font-bold pt-36">
        {{ data?.header?.heading }}
      </h1>
      <p class="text-lg text-center text-white my-4">
        {{ data?.header?.text }}
      </p>
      <button
        class="-tracking-wider bg-transparent border border-[#fff] text-[#fff] py-2 px-4 rounded-md hover:bg-[linear-gradient(to_right_bottom,_#243ea1,_#283aa2,_#2d36a3,_#3231a3,_#372ca3,_#3f2ba4,_#462aa6,_#4d28a7,_#572baa,_#602eae,_#6932b1,_#7235b4)] hover:border-none"
        @click="openModal">
        Get a Quote
      </button>
    </div>
  </section>

  <section class="dark:bg-none section-spacing px-4 mt-10 relative z-10">
    <div class="container-wrapper-xl">
      <FloatingList :heading="data?.google_autocomplete?.heading" :subheading="data?.google_autocomplete?.subheading"
        :expertisetext="data?.expertise?.expertisetext" :textcontent="data?.expertise?.textcontent"
        :text="data?.google_autocomplete?.text" :keywords="data?.google_autocomplete?.keywords" />
      <WrGoogleRating />
    </div>


  </section>

  <section class="mt-10 bg-[#5F4CA4] pt-3">
    <WrContactUsCarouselSection :data="data?.contact_us_carousel" />
  </section>

  <section class="max-w-screen-lg px-4 xl:mt-28 mt-16 relative z-10 mx-auto">
    <WrExpertiseSection :expertise="data?.expertise" />
  </section>

  <section class="section-spacing relative z-10">
    <div class="container-wrapper-xl">
      <WrWhoAreWeCard :heading="data?.service_content?.heading" :subheading="data?.service_content?.subheading"
        :content="data?.service_content?.text" />
    </div>
  </section>

  <section class="relative z-10 section-spacing">
    <div class="container-wrapper-xl">
      <WrImageContent :whyChooseUs="data?.why_choose_us" :header="'Let\'s Start Together'" :text="imageContent"
        :src="'/images/why-chose-us.webp'" height="360" width="466" @openModal="openModal" />
    </div>
  </section>

  <section class="section-spacing relative z-10">
    <div class="container-wrapper-xl">
      <WrOurPromiseSection :data="data?.our_promises" />
    </div>
  </section>

  <WrOurServiceSection title="Our Services" description="" />

  <section class="relative z-10 section-spacing overflow-visible order-9">
    <div class="container-wrapper-lg w-full relative">
      <div class="hidden  dark:block opacity-30  md:size-[764px] rounded-full 
         bg-[linear-gradient(136.28deg,_rgba(51,4,79,0)_30.43%,_#260049_54.53%,_#36006F_92.37%)] 
         absolute -top-[30%] -left-[67%]">
      </div>

      <div class="hidden  dark:block opacity-50 size-[190px] rounded-full 
         bg-[image:var(--bg-circle-top-light)] 
         absolute -bottom-[15%] right-0 top-0">
      </div>
      <WrSelectedProject />
    </div>
  </section>

  <section class="relative z-10 section-spacing dark:bg-none overflow-visible order-9">
    <div class="container-wrapper-lg w-full relative">
      <div class="hidden  dark:block opacity-30  md:size-[764px] rounded-full 
         bg-[linear-gradient(136.28deg,_rgba(51,4,79,0)_30.43%,_#260049_54.53%,_#36006F_92.37%)] 
         absolute -top-[30%] -left-[67%]">
      </div>

      <div class="hidden  dark:block opacity-50 size-[190px] rounded-full 
         bg-[image:var(--bg-circle-top-light)] 
         absolute -bottom-[15%] right-0 top-0">
      </div>
      <WrSelectedProject />
    </div>
  </section>
  <WrContactFormPopup :isOpen="visible" @close="visible = false" class="z-30" />
</template>
